// @core/api/endpoints/workflow/run_test_case.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RunTestCaseRequest,
  TestResultResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Run test case
 * Executes the pipeline in DRY_RUN mode using the test case's mock data and validates assertions.
 */
export async function RunTestCase(
  test_case_id: string,
  data: RunTestCaseRequest,
  options?: RequestOptions
): Promise<TestResultResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/test-cases/:test_case_id/run`;
  requestPath = requestPath.replace(':test_case_id', encodeURIComponent(test_case_id));
  const requestOptions = options;
  return client.post<TestResultResponse>(requestPath, data, requestOptions);
}
